import { FILES_EXPORT_FORMATS } from '../config/fileTypes.ts';

export const isDocWithWrongType = (type: string): boolean => {
	if (type === '') {
		// this conditions was added due to the input returns empty type field in a file on Google Chrome at Windows
		// https://jira.atlassian.com/browse/CONFDEV-77360
		return false;
	}
	return !Object.values<string>(FILES_EXPORT_FORMATS).includes(type);
};

export const DocExceededSizeLimit = (docSize: number, limit: number): boolean => docSize > limit;
